import { render, staticRenderFns } from "./BrowseProduct.vue?vue&type=template&id=3a23842e&scoped=true"
import script from "./BrowseProduct.vue?vue&type=script&lang=js"
export * from "./BrowseProduct.vue?vue&type=script&lang=js"
import style0 from "./BrowseProduct.vue?vue&type=style&index=0&id=3a23842e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23842e",
  null
  
)

export default component.exports